import request from '@/utils/request'

//手机号查看记录列表
export function queryMobileQueryRecordList(data) {
  return request({
    url: '/crmContact/queryMobileQueryRecordList',
    method: 'post',
    data: data
  })
}
